import type { BranchKey } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { ChangeBranchBaseForm } from './ChangeBranchBaseForm'
type Props = {
  branchKey: BranchKey
}

export const ChangeBranchBaseButton = ({ branchKey }: Props) => {
  const translate = useTranslate()

  return (
    <Popover>
      <PopoverButton as="div">
        <OperationsLoadedButton startIcon="Pencil">
          {translate('branchDetailsPanel.tabs.manage.changeBaseBranch')}
        </OperationsLoadedButton>
      </PopoverButton>
      <ActionsMenuPanel anchor={{ to: 'right' }} className="max-w-lg!">
        <ChangeBranchBaseForm branchKey={branchKey} />
      </ActionsMenuPanel>
    </Popover>
  )
}
